import { render, staticRenderFns } from "./MainSettingsIpForm.vue?vue&type=template&id=158d77ca&"
import script from "./MainSettingsIpForm.vue?vue&type=script&lang=js&"
export * from "./MainSettingsIpForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports